import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { RequestHelper } from '../../../../../shared/helper/request.helper';
import { NavigationConstant } from '../../../../../shared/constant/navigation.constant';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {OvoStorage} from '../../../../../shared/storage/ovo.storage';
import { LinkajaStorage } from '@shared/storage/linkaja.storage';

@Component({
  selector: 'app-payment-linkaja',
  templateUrl: './linkaja-payment.component.html',
  styleUrls: ['./linkaja-payment.component.css']
})
export class PaymentLinkajaComponent implements OnInit {
  form: FormGroup;
  inquiryResponse: any;
  isLoading: boolean;
  isSubmitted: boolean;
  hostname: any = environment.hostName;
  trxId: String;
  refNum: String;
  phoneNumber: String;
  amount: any;

  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private linkajaStorage: LinkajaStorage
  ) {
    this.isLoading = false;
    this.isSubmitted = false;
  }

  ngOnInit() {
    if(this.linkajaStorage.data == null){
      this.router.navigate([NavigationConstant.LINKAJA_IDENTIFY]);
    }
    this.form = new FormBuilder().group({
      linkajaCode: [null, Validators.required]
    });

    const formatter = new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
    });

    this.trxId = this.linkajaStorage.data.trx_id;
    this.phoneNumber = this.linkajaStorage.data.dataLogin.phoneNumber;
    this.refNum = this.linkajaStorage.data.ref_num;
    this.amount = formatter.format(this.linkajaStorage.data.amount);
  }

  submitInquiry() {
    this.isSubmitted = true;
    if(!this.form.valid){
      return;
    }

    var paymentDto = {
      amount: this.linkajaStorage.data.amount,
      failed_url: this.linkajaStorage.data.failed_url,
      success_url: this.linkajaStorage.data.success_url,
      trx_id: this.linkajaStorage.data.trx_id,
      ref_num: this.linkajaStorage.data.ref_num,
      status: this.form.getRawValue().linkajaCode === '000000' ? 'SUCCESS' : ''
    };
    
    this.isLoading = true;
    this.apiService.post(environment.apiUrl+'linkaja/notify-transaction', paymentDto).subscribe((data) => {
      this.linkajaStorage.paymentResult = data;
      return this.router.navigate([NavigationConstant.LINKAJA_PAYMENT_RESULT]);
    }, (err) => this.isLoading = false);
    this.isLoading = false;
  }

  home() {
    this.apiService.home();
  }

}